import React from "react";
import { toElementProps } from "../../Element";

export function BlockFooterStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-footer": {
            padding: "64px 0",
            backgroundColor: "black !important",

            color: "white",
            "& *": {
                color: "white",
            },

            "& .menu-links": {
                display: "grid",
                gridAutoFlow: "row",
                gridGap: "8px",

                "& .menu-link": {
                    textAlign: "end",
                    fontSize: "16px",
                    color: "white !important",
                },

                [MobileBreakpoint]: {
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",

                    "& .menu-link": {
                        padding: "10px 8px",
                    },
                },
            },

            "& .socials": {
                filter: "brightness(0) invert(1)",
            },

            [MobileBreakpoint]: {
                padding: "20px",

                "& > div": {
                    display: "flex",
                    //flexDirection: "column-reverse",
                },
            },
        },
    };
}

export default function BlockFooter(props) {
    const elProps = toElementProps(props, { className: ["block-footer"] });
    return <div {...elProps}>{props.children}</div>;
}
